import { useEffect, useState } from 'react'

import { useDocumentTitle } from '@core/hooks/useDocumentTitle'

/**
 * Hook that returns the initial document title, even if title is later changed
 */
export const useInitialDocumentTitle = () => {
  const currentTitle = useDocumentTitle()

  const [initialTitle, setInitialTitle] = useState<string>(currentTitle)

  useEffect(() => {
    if (!initialTitle) {
      setInitialTitle(currentTitle)
    }
  }, [initialTitle, currentTitle])

  return initialTitle
}
